import { FilterGroup } from 'api-paths-cas';
import { getCourseFilter } from './course';
import { getStatusFilter } from './status';
import { IGetFilterGroupsProps } from '..';
import { notEmpty } from '@/utilities/helpers';

export const getOffersGroupFilterGroup = (props: IGetFilterGroupsProps): FilterGroup => {
  return {
    name: 'OFFERS',
    filters: [getCourseFilter(props), getStatusFilter(props)].filter(notEmpty),
  };
};
